export default __webpack_public_path__ + "static/media/background2.69d1aee7.png";